import ApiRoutes from "api/apiRoutes";
import { exeRequest } from "http/requestConfig";

export default class AssureClassService {

    static getAll(options, sCallBack, eCallBack) {
        ApiRoutes.assureClassResource.resourceOptions = Object.assign({}, ApiRoutes.assureClassResource.resourceOptions, options);
        exeRequest(ApiRoutes.assureClassResource, {}, sCallBack, eCallBack)
    }
}